/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
// idSlice.js
import { createSlice } from '@reduxjs/toolkit';


const initialState={
    selectedUsers:{
        dataWithName:[],
        data:[],
        editData:'',
        isDataModal:'',
        checkedArr:[[null]], 
        isCheckedAll:[[true]],
        curIndex:0,
        searchVal:'',
        
    }
    
}
const usersSlice = createSlice({
    name: 'selectedUsers',
    initialState: initialState,
    reducers: {
        addUsers:(state,action)=>{
            state.selectedUsers.checkedArr[state.selectedUsers.curIndex]=action.payload[0]
        },
        pushArray:(state,action)=>{
            state.selectedUsers.checkedArr.unshift(state.selectedUsers.data)
            state.selectedUsers.isCheckedAll.unshift([true])
        },
        popArray:(state,action)=>{
            state.selectedUsers.checkedArr.splice(action.payload[0],1)
            state.selectedUsers.isCheckedAll.splice(action.payload[0],1)
        },
        setCurIndex:(state,action)=>{
            state.selectedUsers.curIndex=action.payload[0]
        },
        toggleRowSelection: (state, action) => {
            let column=action.payload[0]
            const dataItems=action?.payload[1]
            const dataLength=action?.payload[1]?.length
            if(state.selectedUsers?.checkedArr[state.selectedUsers.curIndex]?.includes(column)){
                let filteredArr=state.selectedUsers?.checkedArr[state.selectedUsers.curIndex]?.filter((item)=>item!==column)
                state.selectedUsers.checkedArr[state.selectedUsers.curIndex]=filteredArr
                state.selectedUsers.isCheckedAll[state.selectedUsers.curIndex]=false

            }
            else{
                state.selectedUsers.checkedArr[state.selectedUsers.curIndex].push(column)
                const allItemsPresent = dataItems.every(item => state.selectedUsers.checkedArr[state.selectedUsers.curIndex]?.includes(item.user_id));
                if(allItemsPresent){
                    state.selectedUsers.isCheckedAll[state.selectedUsers.curIndex]=true

                }else{
                    state.selectedUsers.isCheckedAll[state.selectedUsers.curIndex]=false
                }
    
            }

        },
        selectAllRows:(state,action)=>{
            const index=state.selectedUsers.curIndex
            if(action.payload[0]===false){
                state.selectedUsers.checkedArr[index]=state.selectedUsers.checkedArr[index].filter(
                    (element) => !action.payload[1]?.map((item)=>item?.user_id).includes(element)
                );
                state.selectedUsers.isCheckedAll[index]=false
            }
            else{
                const newData = action.payload[1]?.map((item) => item?.user_id);

                // Filter out elements that already exist in state.selectedUsers.checkedArr[index]
                const uniqueData = newData.filter((item) => !state.selectedUsers.checkedArr[index].includes(item));
                // state.selectedUsers.checkedArr[index].push(action.payload[1]?.data?.map((item)=>item?.user_id))
                state.selectedUsers.checkedArr[index].push(...uniqueData)
                state.selectedUsers.isCheckedAll[index]=true
            }
            
        },
        addAllInitially:(state,action)=>{
        
            if(action.payload.length>1){
                if(action.payload[1]==="sub_div"){
                    state.selectedUsers.dataWithName=action.payload[0]?.map((item)=>({"id":item?.user_id,"name":item?.sub_division_name}))
                    state.selectedUsers.data=action.payload[0]?.map((item)=>item?.user_id)

                }else{
                    state.selectedUsers.editData=action.payload[0]
                }

            }else{
                state.selectedUsers.data=action.payload[0]?.map((item)=>item?.user_id)
            }
            
        },
        fillEmptyArray:(state,action)=>{
            state.selectedUsers.checkedArr[0]=action.payload[0]?.map((item)=>item?.user_id)
            if(action.payload[1]!==undefined&&(action.payload[1]===action.payload[0]?.length)){
                state.selectedUsers.isCheckedAll[0]=true
            }
        },
        searchReducer:(state,action)=>{
            const allExistMethod1 = action?.payload[0]?.every((item2) =>
                state.selectedUsers.checkedArr[action.payload[1]]?.some((item1) => item1 === item2.user_id)
            )
            if(allExistMethod1){
                state.selectedUsers.isCheckedAll[action.payload[1]]=true
            }
            else{
                state.selectedUsers.isCheckedAll[action.payload[1]]=false
            }
            
        },
        searchValSetter:(state,action)=>{
            state.selectedUsers.searchVal=action.payload[0]
        },
        handleIsAddModal:(state,action)=>{
            state.selectedUsers.isDataModal=action.payload[0]
        },
        resetProviderArray:(state,action) =>{
            state.selectedUsers.checkedArr[0]=[]
            state.selectedUsers.isCheckedAll[0]=false
        },
        resetOrgList:(state)=>{
            state.selectedUsers.checkedArr=[[null]], 
            state.selectedUsers.isCheckedAll=[[true]],
            state.selectedUsers.curIndex=0
            state.selectedUsers.data=[],
            state.selectedUsers.dataWithName=[],
            state.selectedUsers.editData=[]
            state.selectedUsers.searchVal='',
            state.selectedUsers.isDataModal=''

        },
       

    }
});

export const { resetProviderArray,handleIsAddModal,searchValSetter,resetOrgList,searchReducer,fillEmptyArray,toggleRowSelection,selectAllRows,addAllInitially,addUsers,pushArray,popArray,setCurIndex} = usersSlice.actions;
export default usersSlice.reducer;
